import { render, staticRenderFns } from "./urgentso.vue?vue&type=template&id=858f8f6a&scoped=true&"
import script from "./urgentso.vue?vue&type=script&lang=js&"
export * from "./urgentso.vue?vue&type=script&lang=js&"
import style0 from "./urgentso.vue?vue&type=style&index=0&id=858f8f6a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858f8f6a",
  null
  
)

export default component.exports